import React from "react";
import PicturesShell from "../PicturesShell";
import RotateDeviceGraphic from "../RotateDeviceGraphic";
import "./style.css";
import "../../styles/pictures-status-screens.css";

export default function RotateDeviceScreen({
  badge = "Rotate device",
  title = "Turn your device sideways",
  description = "Photo capture works best in landscape mode. Rotate your phone to continue.",
}) {
  return (
    <PicturesShell
      mainClassName="pi-pictures-main--center pi-pictures-main--status pi-pictures-main--rotate"
      badge={badge}
    >
      <div className="pi-pictures-status-card pi-pictures-status-card--premium pi-pictures-status-card--rotate">
        <span className="pi-pictures-label">{badge}</span>
        <div className="pi-pictures-status-card__hero pi-pictures-status-card__hero--rotate">
          <RotateDeviceGraphic />
        </div>
        <div className="pi-rotate-hint" aria-hidden="true">
          <span className="pi-rotate-hint__badge">Portrait</span>
          <span className="pi-rotate-hint__arrow">→</span>
          <span className="pi-rotate-hint__badge pi-rotate-hint__badge--active">Landscape</span>
        </div>
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
    </PicturesShell>
  );
}
